<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <ChangeLogCollapse
            class="mt-2"
            v-if="visibleChangeLog && data.id"
            :id="data.id"
            :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
            :mappings="data.fieldLogs"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
import { Card, Form } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { useRoute } from "vue-router";
import { state as stateApp } from "../../../../app.logic";
import { onCallChangeLog } from "../../../../utils/form";
import { callChanges, createFormTitle, createSearchOneCriteria, initForm, initState, isLoading, onClickModalOk } from "../../haz/haz/haz.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../../components/input/template-builder/TemplateBuilder")),
        ChangeLogCollapse: defineAsyncComponent(() => import("../../../../components/change-log/ChangeLogCollapse"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext },
        routerPrefix: { default: "informs" },
        viewOnly: { default: false },
        form: {},
        setAppPageHeader: { default: true },
        visibleChangeLog: { default: true },
        requestDocKeys: { default: () => ["16", "17"] }
    },
    setup(props) {
        const route = useRoute();
        const id = props.form ? props.form.id : route.params?.id;
        const state = reactive(initState({ props }));
        const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
        const refs = reactive({ form: null });
        initForm({ props, data, refs, route, state });
        const callOnClickModalOk = () => onClickModalOk({ data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            state,
            title,
            isLoading,
            callChanges,
            callOnClickModalOk,
            createSearchOneCriteria,
            onCallChangeLog
        };
    }
});
</script>
